import { Box, DialogContent, DialogTitle } from "@mui/material";
import { orderItemBusiness } from "api/bussiness/order/order-item-business";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import { observer } from "mobx-react-lite";
import { IUpdateUnitPrice } from "mobx-stores/_models/orders/order-item";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useEffect } from "react";
import { DialogForm } from "share-components/templates/form/dialog-form";
import { getUpdateUnitPriceSchema } from "../schema";

export const EditUnitPrice = observer(() => {
  const {
    orderManagement: {
      openEditPrice,
      setProp,
      selectedOrderItem,
      getOrderDetail,
      orderDetail,
    },
  } = useStores();

  const {
    form: { controls, isValid },
    setDefaults,
    submitHandler,
  } = useForm<IUpdateUnitPrice>(getUpdateUnitPriceSchema(), {
    id: "",
    unitPrice: 0,
  });
  const onCloseHandler = useCallback(() => {
    setProp("openEditPrice", false);
    setProp("selectedOrderItem", null);
  }, [setProp]);

  useEffect(() => {
    if (selectedOrderItem) {
      setDefaults({
        id: selectedOrderItem.id,
        unitPrice: selectedOrderItem.unitPrice,
      });
    }
  }, [selectedOrderItem, setDefaults]);

  const saveHandler = useCallback(
    async (data: IUpdateUnitPrice) => {
      try {
        if (!selectedOrderItem?.id) return;
        await orderItemBusiness.updateItemPrice(
          selectedOrderItem?.id,
          data.unitPrice || 0
        );
        if (orderDetail?.id) {
          await getOrderDetail(orderDetail?.id);
        }
        onCloseHandler();
      } catch (ex) {
        console.error(ex);
      }
    },
    [getOrderDetail, onCloseHandler, orderDetail?.id, selectedOrderItem?.id]
  );
  return (
    <DialogForm
      open={openEditPrice}
      fullWidth
      maxWidth={"sm"}
      onClose={onCloseHandler}
      onCancelBtnClicked={onCloseHandler}
      onSaveBtnClick={async () => {
        await submitHandler(saveHandler);
      }}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>{`Cập nhật đơn giá - ${selectedOrderItem?.product?.name}`}</DialogTitle>
      <DialogContent>
        <Box sx={{ marginTop: "10px" }}>
          <DynamicForm controls={controls}></DynamicForm>
        </Box>
      </DialogContent>
    </DialogForm>
  );
});
